import { render, staticRenderFns } from "./TournamentPauseModal.vue?vue&type=template&id=38a321ea&"
import script from "./TournamentPauseModal.vue?vue&type=script&lang=js&"
export * from "./TournamentPauseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports